module.exports = __webpack_public_path__ + "static/img/iosxz.7f02ebc.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/iosxz.png
// module id = r8or
// module chunks = 1